import React, { PureComponent } from 'react';
import { string, oneOfType, func, bool, number, shape } from 'prop-types';
import { connectToggleRefinement } from 'react-instantsearch-core';
import compose from 'lodash/flowRight';
import { ListItem } from 'components';
import { withFeatureFlags } from 'connectors';

class ListItemConnect extends PureComponent {
    imgMapping = {
        has_free_delivery: 'truck',
        has_1day_delivery: 'clock',
        has_relay_delivery: 'location',
    };

    static propTypes = {
        label: string.isRequired,
        attribute: string.isRequired,
        currentRefinement: oneOfType([string, bool]),
        refine: func.isRequired,
        value: oneOfType([string, number, bool]), // eslint-disable-line react/no-unused-prop-types
        index: number,
        count: shape({
            checked: number,
            unchecked: number,
        }),
        canRefine: bool,
        setItemsChecked: func,
        className: string,
        showToggleCount: bool.isRequired,
        onFilterSelected: func.isRequired,
    };

    static defaultProps = {
        canRefine: false,
        currentRefinement: false,
        value: 'true',
        index: null,
        setItemsChecked: null,
        className: null,
        count: null,
    };

    componentDidMount() {
        const { currentRefinement, setItemsChecked, index } = this.props;
        if (setItemsChecked) {
            const active =
                currentRefinement === true || currentRefinement === 'true';
            setItemsChecked(index, active);
        }
    }

    componentDidUpdate(prevProps) {
        const { currentRefinement, index, setItemsChecked } = this.props;
        if (
            setItemsChecked &&
            currentRefinement !== prevProps.currentRefinement
        ) {
            setItemsChecked(index, currentRefinement);
        }
    }

    handleClick = () => {
        const {
            currentRefinement,
            refine,
            index,
            setItemsChecked,
            onFilterSelected,
        } = this.props;
        const active =
            currentRefinement === true || currentRefinement === 'true';
        refine(!active);
        if (active === false) {
            onFilterSelected({ value: true });
        }

        if (setItemsChecked) setItemsChecked(index, !active);
    };

    render() {
        const {
            label,
            attribute,
            currentRefinement,
            className,
            count,
            canRefine,
            showToggleCount,
        } = this.props;
        return (
            <ListItem
                className={className}
                value={attribute}
                label={label}
                checked={
                    currentRefinement === true || currentRefinement === 'true'
                }
                onClick={this.handleClick}
                count={showToggleCount ? count.unchecked : null}
                disabled={!canRefine}
                iconItem={this.imgMapping[attribute]}
            />
        );
    }
}

export default compose(
    withFeatureFlags({
        showToggleCount: 'instantSearch.filters.showToggleCount',
    }),
    connectToggleRefinement,
)(ListItemConnect);
